import SpecialtyFileUploadSection from 'components/SpecialtyFileUploadSection';
import { SPECIALTY_FILE_TYPES } from 'constants/fileTypes';
import { useSpecialtyCarriers } from 'hooks/index';
import { useAppSelector } from 'hooks';
import { Alert, AlertIcon, AlertDescription } from '@chakra-ui/react';

interface SpecialtyDeclarationUploadProps {
  isLocked?: boolean;
}

const SpecialtyDeclarationUpload = ({ isLocked = false }: SpecialtyDeclarationUploadProps) => {
  const { features } = useSpecialtyCarriers();
  const paymentMethod = useAppSelector(
    (state) => state.specialtyForm.data.billing.payment_method,
  );
  const isDeclarationRequired = paymentMethod !== 'agency_bill';

  if (!features.canUploadDeclaration) {
    return (
      <Alert status="error" mb="20px">
        <AlertIcon />
        <AlertDescription>
          Declaration Pages upload is disabled. No specialty carriers (Hagerty
          or Aviva Elite) are configured in your organization. Please contact
          your administrator to add these carriers before uploading declaration
          pages.
        </AlertDescription>
      </Alert>
    );
  }

  return (
    <SpecialtyFileUploadSection
      title="Declaration Pages Upload"
      fieldLabel="Policy Declaration Pages"
      fileType="declaration"
      fileTypeId={SPECIALTY_FILE_TYPES.DECLARATION_PAGES}
      badgeText="Declaration Pages"
      acceptedFileTypes=".pdf,.eml,.msg"
      infoAlertText={isDeclarationRequired ? "<strong>Note:</strong> If you've received approval to bind from the carrier underwriter but have not yet received the policy declarations, please upload the 'Intent to Bind' email using the Policy Declarations upload box." : undefined}
      sectionId="sectionSpecialtyDeclarationUpload"
      isLocked={isLocked}
      isRequired={isDeclarationRequired}
    />
  );
};

export default SpecialtyDeclarationUpload;
